import PropTypes from 'prop-types';
import React, { Component } from 'react';

// eslint-disable-next-line react/prefer-stateless-function
class OverMenu extends Component {
  render() {
    return (
      <div className="overmenu">
        {this.props.children}
      </div>
    );
  }
}

OverMenu.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
};

export default OverMenu;
